import { FC } from 'react'
import { SvgProps } from './svgProps'

const UnderwearWomenIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    fill={color || '#000000'}
    width={width || '32'}
    height={height || '32'}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512.001 512.001"
  >
    <g>
      <g>
        <path
          d="M511.946,297.813l-17.102-145.37c-0.475-4.037-3.897-7.08-7.962-7.08H320.659c5.626-11.042,3.832-24.921-5.393-34.146
			c-11.461-11.462-30.11-11.462-41.57,0c-5.495,5.495-12.354,21.34-17.696,35.354c-5.341-14.014-12.199-29.858-17.695-35.354
			c-11.461-11.462-30.11-11.462-41.57,0c-9.225,9.225-11.018,23.104-5.393,34.146H25.119c-4.065,0-7.487,3.043-7.962,7.08
			L0.055,297.813c-0.277,2.356,0.503,4.713,2.13,6.438c0.653,0.693,1.418,1.246,2.25,1.661l-0.004,0.007l192.589,96.294
			c9.375,4.688,19.872,7.166,30.354,7.166h57.251c10.483,0,20.979-2.478,30.354-7.166l192.589-96.294l-0.004-0.009
			c0.832-0.415,1.598-0.968,2.25-1.661C511.442,302.526,512.223,300.169,511.946,297.813z M285.033,122.555
			c2.605-2.605,6.026-3.907,9.448-3.907s6.843,1.302,9.448,3.907c5.21,5.21,5.21,13.686,0,18.896
			c-3.274,3.274-18.537,9.896-34.827,15.931C275.135,141.092,281.756,125.832,285.033,122.555z M301.389,161.398h178.364
			l2.138,18.171H270.022c-1.652-1.5-3.212-2.769-4.597-3.821C275.157,172.369,290.054,166.896,301.389,161.398z M208.072,122.555
			c2.605-2.605,6.026-3.907,9.448-3.907s6.843,1.302,9.448,3.907c3.274,3.274,9.896,18.537,15.931,34.827
			c-16.289-6.033-31.549-12.655-34.827-15.931C202.863,136.241,202.863,127.765,208.072,122.555z M32.249,161.398h178.363
			c11.335,5.498,26.232,10.972,35.964,14.35c-1.385,1.052-2.945,2.322-4.597,3.821H30.111L32.249,161.398z M45.284,308.421
			c10.255,1.168,22.056,3.061,34.63,6.111c33.437,8.111,78.611,26.193,110.362,66.385L45.284,308.421z M321.683,380.938
			c25.442-32.382,62.364-54.664,109.947-66.295c12.714-3.107,24.674-5.028,35.063-6.21L321.683,380.938z M428.308,298.95
			c-55.502,13.463-99.35,41.966-126.804,82.43c-5.085,7.494-13.283,11.967-21.93,11.967h-47.147c-8.646,0-16.845-4.474-21.93-11.967
			c-27.453-40.463-71.302-68.966-126.804-82.43c-28.893-7.009-53.711-8.277-66.643-8.373l11.174-94.975h200.9
			c-3.939,7.095-6.793,15.811-6.793,26.188c0,4.427,3.589,8.017,8.017,8.017c4.427,0,8.017-3.589,8.017-8.017
			c0-11.487,5.04-20.222,10.249-26.188h14.775c5.21,5.965,10.25,14.699,10.25,26.188c0,4.427,3.589,8.017,8.017,8.017
			s8.017-3.589,8.017-8.017c0-10.377-2.854-19.093-6.793-26.188h200.9l11.174,94.975
			C482.018,290.672,457.199,291.943,428.308,298.95z"
        />
      </g>
    </g>
  </svg>
)

export default UnderwearWomenIcon
